import { Component, Inject } from '@angular/core';
import { AuthService } from '../../shared/auth.service';
import { BreadcrumbService } from '../../shared/breadcrumb/breadcrumb.service';
import { Kernantwort } from '../../shared/response/kernantwort.model';
import { SessionService } from '../../shared/session.service';
import { Kategorie } from '../kategorie/kategorie.model';
import { Kontakt } from '../kontakt/kontakt.model';
import { HttpClient } from "@angular/common/http";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
  L10N_CONFIG,
  L10N_LOCALE,
  L10nConfig,
  L10nLocale,
  L10nTranslatePipe,
  L10nTranslationService
} from 'angular-l10n';
import { APIConfigService } from "../../api.config.service";
import { AngularMaterial2Module } from "../../app.module.material";
import { LoggerService } from '../../shared/logger.service';

import { Subscription } from 'rxjs';
import { Data } from "../../providers/data";
import { ErrorHelper } from "../../shared/error.helper";
import { Lieferant } from '../../shared/lieferant.model';

const PATH_FILE = 'app/protected/ansprechpartner/ansprechpartner.component.ts';
const OBJ_LNG_NAME = 'kontakt';
const BACKEND_PATH_PREFIX = 'kontakt/';

@Component({
    selector: 'oase-ansprechpartner',
    templateUrl: './ansprechpartner.component.html',
    styleUrls: ['./ansprechpartner.component.css'],
    standalone:true,	imports: [ AngularMaterial2Module, L10nTranslatePipe ]

})
export class AnsprechpartnerComponent {
  OBJ_LNG_NAME = OBJ_LNG_NAME; // Wird benötigt das Konstanten nicht im Template refernziert werden können.
  data: Kontakt[] = Array<Kontakt>();
  kategorieListe: Kategorie[] = Array<Kategorie>();
  fehlerMain: Kernantwort = null;
  maxSortierung: number = 1;
  ladedaten: boolean = true;
  ladedatenKontakte: boolean = true;
  dialogrunningajaxcall: boolean = false;
  seconddialogrunningajaxcall: boolean = false;
  lieferant: Lieferant;
  subscription:Subscription;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public authService: AuthService,
	public apiConfigService: APIConfigService,
	public http: HttpClient,
	@Inject(L10N_LOCALE) public locale: L10nLocale,
	@Inject(L10N_CONFIG) private config: L10nConfig,
	public translation: L10nTranslationService,
	public sessService: SessionService,
    public title: Title,
    private _logger: LoggerService,
    private _dataService: Data
  ) {
     // Set document title.
      this.title.setTitle(this.getTitle());

      this.getKontakte();

  }

   private getKontakte() {
    this._logger.log(PATH_FILE + ' - getKontakte Begin');

    this.ladedatenKontakte = true;
    this.ladedaten = this.ladedatenKontakte;

    this.http
      .get<Kategorie[]>(this.apiConfigService.REST_API_BASE() + 'kontakt/zeige')
      //  // Um mehrfachaufrufe zu verhindern
      .subscribe({
        next: (data) => {
          // this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
          // this.kategorieListe = data.json() as Kategorie[];
          this.kategorieListe = data;
          this._logger.log(PATH_FILE + ' - Ansprechpartner = ', this.kategorieListe);
          this._logger.log(PATH_FILE + ' - getKontakte End');
          this.ladedatenKontakte = false;
          this.ladedaten = this.ladedatenKontakte;
          // Initial-Sortierung da dies über Attribute im HTML nicht korrekt funktioniert
        },
        error: (err) => {
          this.ladedatenKontakte = false;
          this.ladedaten = this.ladedatenKontakte;
          ErrorHelper.handleError(err, "Fehler beim holen der Kontakte", this._logger, this.translation)
        },
        complete: () => {
          this.ladedatenKontakte = false;
          this.ladedaten = this.ladedatenKontakte;
          this._logger.log(PATH_FILE + ' - Holen der Kontakte abgeschlossen')
        }
      });
  } // getKontakte


    getTitle() {
      return this.translation.translate('kontakt.title') + ' - ' + this.translation.translate('project.title');
    }

  setzeFehler(fehler: Kernantwort) {
     this.fehlerMain = fehler;
  }

  ngOnInit() {
    this.subscription = this._dataService.lieferant$.subscribe(item => this.lieferant = item);
  }
}
